let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8Q6ef"), load("5uN9h"), load("7EorR"), load("4uUio")]).then(() => parcelRequire('ayZRr'));